import { IBreadcrumbItem } from "office-ui-fabric-react/lib/Breadcrumb";
import { BreadCrumbsActiontypes, IBreadCrumbsAction } from './ActionTypes'

export function updateBreadCrumbs(param: IBreadcrumbItem[]): IBreadCrumbsAction {
    return {
        type: BreadCrumbsActiontypes.UPDATE,
        payload: {
            items: param
        }
    };
}